import { useMemo } from 'react';
import { useFeatureValue } from '../contexts/growthbook';
import { useEligibility } from '../contexts/EligibilityContext';
import {
  FRESH_USER,
  TEMPORARY_ADDRESS_REMOTENESS_LEVEL,
  ULTRA_FRESH_USER,
} from '../constants';
import { AuthWithCustomerTagsHook } from '@monofront/types';

/**
 * Enhance user's tags with "ephemeral" ones.
 *
 * TODO: LF-1675 - shared useAuthentication hook
 */
export const useUserTags = (useAuthentication: AuthWithCustomerTagsHook) => {
  const { customer } = useAuthentication();
  const { eligibility } = useEligibility();
  const temporaryAddressAreaLevel = useFeatureValue(
    ...TEMPORARY_ADDRESS_REMOTENESS_LEVEL,
  );

  const tags = useMemo(() => {
    const tags = new Set(customer?.omsTags ?? []);

    if (eligibility.fresh || eligibility.fresh == null) {
      tags.add(FRESH_USER);
    } else if (customer?.savedAddressCount === 0) {
      tags.delete(FRESH_USER);
    }
    if (eligibility.ultraFresh || eligibility.ultraFresh == null) {
      tags.add(ULTRA_FRESH_USER);
    } else if (customer?.savedAddressCount === 0) {
      tags.delete(ULTRA_FRESH_USER);
    }

    tags.add(`temporary_address_${temporaryAddressAreaLevel}`);

    return Array.from(tags);
  }, [
    customer?.omsTags,
    customer?.savedAddressCount,
    eligibility,
    temporaryAddressAreaLevel,
  ]);

  return tags;
};
